import { render, staticRenderFns } from "./CharacterItem.vue?vue&type=template&id=f825a662&scoped=true"
import script from "./CharacterItem.vue?vue&type=script&lang=ts"
export * from "./CharacterItem.vue?vue&type=script&lang=ts"
import style0 from "./CharacterItem.vue?vue&type=style&index=0&id=f825a662&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f825a662",
  null
  
)

export default component.exports